<template>
  <div>
    <div class="row mt-2" v-if="showFilters" v-show="user.admin || user.usertype === 1">
      <div class="form-group col-lg-4">
        <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
        <Combobox
          class="bg-white"
          name='garage_accredited'
          :placeholder="$t('select_a_item')"
          :options="garages"
          :initial-value="query.garageAccredited"
          label="fantasyName"
          v-model="query.garageAccredited"
          :reduce="garage => garage.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="client">{{ $t('client') }}</label>
        <Combobox
          class="bg-white"
          name='client'
          :placeholder="$t('select_a_item')"
          label="CLI_DSC"
          :options="allClients"
          :initial-value="query.client"
          :reduce="client => client.CLI_ID"
          v-model="query.client"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="services">{{ $t('services') }}</label>
        <Combobox
          class="bg-white"
          name='services'
          :placeholder="$t('select_a_item')"
          :options="serviceTypes"
          :initial-value="query.service"
          label="name"
          v-model="query.service"
          :reduce="serviceType => serviceType.id"
        />
      </div>
    </div>

    <div class="form-group" v-if="showFilters">
      <button
        id="search"
        class="btn btn-primary btn-sm mr-2"
        type="button"
        @click="loadSchedules"
      >
        {{ $t('search') }}
      </button>

      <button
        id="clear"
        class="btn btn-white btn-sm"
        type="button"
        @click="clear"
      >
        {{ $t('clear') }}
      </button>
    </div>

    <FullCalendar
      ref="fullCalendar"
      class='demo-app-calendar mt-2'
      :options='calendarOptions'
      v-show="user.admin || user.usertype === 1"
    >
      <template v-slot:eventContent='arg'>
        <p style="color: #fff; margin: 0 2px">
          <b>{{ arg.timeText }} - </b>
          <i>{{ arg.event.title }}</i>
        </p>
      </template>
    </FullCalendar>

    <b-modal
      :title="modalDetailLabel"
      v-model="showModalDetail"
      size="lg"
      @hidden="onCloseModalDetail"
    >
      <div class="row">
        <div class="form-group col-lg-12">
          <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
          <Combobox
            class="bg-white"
            name='garage_accredited'
            :placeholder="$t('select_a_item')"
            :options="garages"
            :initial-value="detail.garageAccredited"
            label="fantasyName"
            v-model="detail.garageAccredited"
            :reduce="garage => garage.id"
          />
        </div>

        <div class="form-group col-lg-12">
          <label for="client">{{ $t('client') }}</label>
          <Combobox
            class="bg-white"
            name='client'
            :placeholder="$t('select_a_item')"
            label="CLI_DSC"
            :options="allClients"
            :initial-value="detail.client"
            :reduce="client => client.CLI_ID"
            v-model="detail.client"
          />
        </div>

        <div class="form-group col-lg-12">
          <label for="services">{{ $t('services') }}</label>
          <Combobox
            class="bg-white"
            name='services'
            :placeholder="$t('select_a_item')"
            :options="serviceTypes"
            :initial-value="detail.service"
            label="name"
            v-model="detail.service"
            :reduce="serviceType => serviceType.id"
          />
        </div>
      </div>

      <div class="row">
        <div
          class="form-group col-lg-12"
          :class="{ 'has-error': errors.has('service_local') }"
        >
          <label for="service_local">{{ $t('service_local') }}</label>

          <b-form-input
            list="input-list"
            id="service_local"
            name="service_local"
            v-model="detail.address"
            :placeholder="$t('ph_service_local')"
            v-validate="'required'"
            class="form-control"
          />

          <b-form-datalist
            id="input-list"
            :options="addresses"
          />

          <small
            v-show="errors.has('service_local')"
            class="form-text text-muted text-left"
          >
            {{ errors.first("service_local") }}
          </small>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-lg-6">
          <label for="date">{{ $t('date') }}</label>
          <b-form-input
            type="date"
            v-model="detail.date"
          />
        </div>

        <div class="form-group col-lg-6">
          <label for="hour">{{ $t('hour') }}</label>
          <b-form-input
            type="time"
            v-model="detail.hour"
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-lg-12">
          <label for="obs">{{ $t('obs') }}</label>
          <textarea
            type="text"
            id="obs"
            name="obs"
            class="form-control"
            :placeholder="$t('ph_obs')"
            v-model="detail.obs"
          />
        </div>
      </div>

      <template #modal-footer>
        <button
          type="button"
          class="btn btn-secondary m-b"
          @click="showModalDetail = false"
          :disabled="loading"
        >
          {{ $t('close') }}
        </button>

        <button
          type="button"
          class="btn btn-danger m-b"
          :disabled="loading"
          @click="removeSchedule"
          v-if="detail.id"
        >
          {{ $t('remove') }}
        </button>

        <LoaderButton
          @click="save"
          :disabled="cantSave"
          :loading="loading"
        >
          {{ $t('save') }}
        </LoaderButton>
      </template>
    </b-modal>

    <div v-if="user.usertype === 2">
      <PageTitle :route="$route" />

      <PageRowWrapper>
        <b-card-group
          deck
          v-for="item in allSchedules"
          :key="item.id"
          style="width: 100%;"
        >
          <b-card :header="item.client">
            <b-list-group>
              <b-list-group-item
                class="bg"
              >
                <strong><i class="fas fa-calendar-alt text-primary" /> &nbsp;{{ getDateFormatted(item.serviceDate) }}</strong>
              </b-list-group-item>

              <b-list-group-item
                style="text-transform: uppercase"
                class="bg"
              >
                <strong><i class="fas fa-wrench text-primary" /> &nbsp;{{ item.service.name }}</strong>
              </b-list-group-item>

              <textarea
                v-if="item.obs"
                type="text"
                id="obs"
                name="obs"
                class="form-control"
                :placeholder="$t('ph_obs')"
                :value="item.obs"
                readonly
                rows="6"
              />
            </b-list-group>

            <div class="mt-3">
              <a
                :href='`https://www.google.com.br/maps/search/${item.address}`'
                target="_blank"
              >
                <i class="fas fa-map-marker-alt fa-2x text-primary" /> &nbsp;
                <em><u style="color: blue">{{ item.address }}</u></em>
                <i class="fas fa-circle-arrow-right text-primary ml-3" />
              </a>
            </div>
          </b-card>
        </b-card-group>

        <div class="col-lg-12 mb-4" v-if="allSchedules.length === 0">
          <div class="text-center m-t-lg">
            <h1>Nenhum agendamento</h1>
          </div>
        </div>
      </PageRowWrapper>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { request } from '@/lib/http'
import Combobox from '@/components/shared/ComboBox'
import moment from 'moment'
import LoaderButton from '@/components/button/LoaderButton'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ptBr from '@fullcalendar/core/locales/pt-br'

const initialDetail = {
  garageAccredited: undefined,
  client          : undefined,
  service         : undefined,
  address         : '',
  date            : '',
  hour            : '',
  obs             : ''
}
const initialQuery = {
  garageAccredited: undefined,
  client          : undefined,
  service         : undefined
}

export default {
  name: 'Schedule',
  components: {
    FullCalendar,
    Combobox,
    LoaderButton,
    PageTitle,
    PageRowWrapper
  },

  data: function() {
    return {
      refCalendar: undefined,
      showFilters: false,
      calendarOptions: {
        locale: ptBr,
        showNonCurrentDates: false,
        fixedWeekCount: false,
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        customButtons: {
          showFilters: {
            text: 'Filtros',
            click: () => {},
            // icon: 'right-single-arrow'
          }
        },
        headerToolbar: {
          left  : 'prev,next today',
          center: 'title',
          right : 'showFilters dayGridMonth,timeGridWeek,timeGridDay'
        },
        initialView: 'dayGridMonth',
        editable    : true,
        selectable  : true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends    : true,
        select      : this.handleDateSelect,
        eventClick  : this.handleEventClick,
        eventsSet   : this.handleEvents,
        eventChange : this.handleEventChange,
        events      : []
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      allSchedules: [],
      detail      : Object.assign({}, initialDetail),
      allClients  : [],
      loading     : false,
      addresses   : [],
      service     : null,
      query       : Object.assign({}, initialQuery),
      showModalDetail: false,
      modalDetailLabel: ''
    }
  },

  watch: {
    'detail.address'(value) {
      if (!value) {
        return this.addresses = []
      }

      this.service.getPlacePredictions({ input: this.detail.address }, this.displaySuggestions)
    }
  },

  computed: {
    ...mapState({
      garages     : state => state.garageaccredited.all,
      serviceTypes: state => state.servicetypes.all,
      user        : state => state.session.user
    }),

    cantSave() {
      return this.loading || !this.detail.address || this.errors.has('service_local')
    }
  },

  methods: {
    handleDateSelect(selectInfo) {
      if (selectInfo.startStr < moment().format('YYYY-MM-DD')) {
        return
      }

      this.detail.date = selectInfo.startStr

      this.modalDetailLabel = `Novo agendamento - ${moment(selectInfo.startStr).format('DD/MM/YYYY')}`
      this.showModalDetail = true
    },

    handleEventClick(clickInfo) {
      const schedule = this.allSchedules.find(e => e.id == clickInfo.event.id)

      const {
        id,
        garageAccredited,
        client,
        service,
        serviceDate,
        address,
        obs
      } = schedule

      this.detail = {
        garageAccredited: garageAccredited.id,
        service         : service.id,
        date            : moment(serviceDate).format('YYYY-MM-DD'),
        hour            : moment(serviceDate).format('HH:mm'),
        address,
        id,
        client,
        obs
      }

      this.modalDetailLabel = `Detalhes [${garageAccredited.fantasyName} - ${moment(serviceDate).format('DD/MM/YYYY HH:mm:ss')}]`
      this.showModalDetail = true
    },

    async handleEventChange({ event }) {
      const { dispatch } = this.$store

      const schedule = this.allSchedules.find(e => e.id == event.id)

      const { garageAccredited, client, service, address, obs } = schedule

      dispatch('overlay/show', true)

      try {
        await request({
          url   : `/schedule/${event.id}`,
          method: 'PATCH',
          data  : {
            garageAccredited: garageAccredited.id,
            service         : service.id,
            serviceDate     : moment(event.startStr).format('YYYY-MM-DD HH:mm:ss'),
            client,
            address,
            obs
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        dispatch('overlay/show', false)
      }
    },

    async loadSchedules() {
      const { dispatch } = this.$store

      dispatch('overlay/show', true)

      const actualEvents= this.refCalendar.getEvents()
      const {
        currentStart,
        currentEnd
      } = this.refCalendar.view

      for (const event of actualEvents) {
        event.remove(event.id)
      }

      try {
        const schedules = await request({
          url   : '/schedule',
          method: 'GET',
          params: {
            currentStart,
            currentEnd,
            ...this.query
          }
        })

        this.allSchedules = schedules

        for (const schedule of schedules) {
          this.refCalendar.addEvent({
            id   : schedule.id,
            title: schedule.garageAccredited.fantasyName,
            start: schedule.serviceDate,
            end  : schedule.serviceDate
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        dispatch('overlay/show', false)
      }
    },

    async save() {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      this.loading = true

      const { date, hour, id, obs } = this.detail

      const obsFormatted = obs
        ? JSON.stringify(this.detail.obs.split(/\r?\n/)).toUpperCase()
        : []

      try {
        await request({
          url   : id ? `/schedule/${id}` : '/schedule',
          method: id ? 'PATCH' : 'POST',
          data  : {
            ...this.detail,
            obs: obsFormatted,
            serviceDate: `${date} ${hour}:00`
          }
        })

        this.showModalDetail = false

        this.detail = Object.assign({}, initialDetail)

        this.loadSchedules()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    getDateFormatted(date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },

    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        return this.addresses = []
      }

      this.addresses = predictions.map(prediction => prediction.description)
    },

    clear() {
      this.query = Object.assign({}, initialQuery)
    },

    async removeSchedule() {
      try {
        this.loading = true

        const { id } = this.detail

        await request({
          url: `/schedule/${id}`,
          method: 'DELETE'
        })

        this.showModalDetail = false

        this.detail = Object.assign({}, initialDetail)

        this.loadSchedules()
      } catch (error) {
        console.log('[ERROR-REMOVE-SCHEDULE] =>', error)
      } finally {
        this.loading = false
      }
    },

    onCloseModalDetail() {
      this.showModalDetail = false
      this.detail = Object.assign({}, initialDetail)
    }
  },

  async mounted () {
    const { dispatch } = this.$store

    dispatch('overlay/show', true)

    this.refCalendar = this.$refs.fullCalendar.getApi()

    this.allClients = await request({
      url   : `clients`,
      method: 'get'
    })

    await dispatch('garageaccredited/fetchAll')
    await dispatch('servicetypes/fetchAll')
    await this.loadSchedules()

    dispatch('overlay/show', false)

    this.service = new window.google.maps.places.AutocompleteService()

    const global = this
    $(`.fc-prev-button, .fc-next-button, .fc-dayGridMonth-button, .fc-timeGridWeek-button, .fc-timeGridDay-button, .fc-today-button`).on('click', () => {
      global.loadSchedules()
    })

    $(`.fc-showFilters-button`).on('click', () => {
      global.showFilters = !global.showFilters
    })
  }

}
</script>

<style scoped lang='css'>
a {
  color: #676A6C !important;
}
.demo-app {
  display: flex;
  min-height: 100%;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}
.demo-app-main {
  flex-grow: 1;
  padding: 1em 0;
}
.fc { /* the calendar root */
  margin: 0 auto;
}

.card-header {
  background-color: #FFC107;
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
}

.bg {
  background-color: #f3f3f3;
  border: 1px solid #ddd;
}
</style>
